<template>
  <div>
    <div class="m-section" v-if="getProgress !== null">
      <div class="m-section__header">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-5 col-12">
            <div class="m-section__headline mb-2">Tu progreso de Menú Diario</div>
          </div>
          <div class="col-md-7 col-12">
            <div class="row justify-content-end align-items-center">
              <div class="col-md-auto pt-3">
                <button class="btn m-section__cta">
                  Descargar Excel
                  <span
                    ><svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.8878 18.5072L6.1121 18.5072C5.5107 18.5072 5.02148 18.9964 5.02148 19.5978L5.02148 19.9094C5.02148 20.5108 5.5107 21 6.1121 21L18.8878 21C19.4892 21 19.9785 20.5108 19.9785 19.9094L19.9785 19.5978C19.9785 18.9964 19.4892 18.5072 18.8878 18.5072Z"
                        fill="white"
                      />
                      <path
                        d="M12.4999 16.0874C12.6915 16.0874 12.8747 16.0088 13.0065 15.8705L17.9143 10.729C18.3396 10.284 18.0237 9.54368 17.4076 9.54368L14.8369 9.54368L14.8369 4.16851C14.8369 3.52443 14.3125 3 13.6684 3L11.3314 3C10.6873 3 10.1628 3.52443 10.1628 4.16851L10.1628 9.54368L7.59212 9.54367C6.97608 9.54367 6.66011 10.284 7.08545 10.729L11.9932 15.8705C12.125 16.0088 12.3082 16.0874 12.4999 16.0874Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </button>
              </div>
              <div class="col-md-auto pt-3">
                <div class="m-section__filter-date">
                  Periodo:
                  <span class="ml-1">
                    <select v-model="valPeriod" @change="changePeriod" class="form-control w-auto">
                      <option :value="0" disabled>Elige un Periodo</option>
                      <option
                        :value="item.value"
                        v-for="(item, index) in getPeriods"
                        :key="index"
                        >{{ item.label }}</option
                      >
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-section__tabs">
        <div class="">
          <tabs :fill="false" circle>
            <tab-pane :title="'level'">
              <span slot="title" class="nav-link-icon d-block"
                >Nivel general<MetricInfoTooltip :content="levelHelpText" /></span
              >
              <div class="tab-h">
                <!-- <div class="letter-level">A = 1, B = 2, C= 3</div> -->
                <line-chart
                  :height="350"
                  ref="bigChart"
                  :chart-data="bigGeneralChart.chartData"
                  :extra-options="bigGeneralChart.extraOptions"
                ></line-chart>
              </div>
            </tab-pane>
            <tab-pane>
              <span slot="title" class="nav-link-icon d-block"
                >Ratio de incidencias<MetricInfoTooltip :content="INCIDENTS_HELP_TEXT" /></span
              >
              <div class="tab-h">
                <bar-chart
                  :height="350"
                  ref="barChart"
                  :chart-data="bigClaimsRatioChart.chartData"
                  :extra-options="bigClaimsRatioChart.extraOptions"
                ></bar-chart>
              </div>
            </tab-pane>
            <tab-pane>
              <span slot="title" class="nav-link-icon d-block"
                >Espera del repartidor (min)<MetricInfoTooltip :content="DEALER_WAIT_HELP_TEXT" /></span
              >
              <div class="tab-h">
                <bar-chart
                  :height="350"
                  ref="barChart"
                  :chart-data="bigRoutesChart.chartData"
                  :extra-options="bigRoutesChart.extraOptions"
                ></bar-chart>
              </div>
            </tab-pane>
            <tab-pane>
              <span slot="title" class="nav-link-icon d-block"
                >Calificación de pedidos<MetricInfoTooltip :content="RATINGS_HELP_TEXT" /></span
              >
              <div class="tab-h">
                <bar-chart
                  :height="350"
                  ref="barChart"
                  :chart-data="bigRatingsChart.chartData"
                  :extra-options="bigRatingsChart.extraOptions"
                ></bar-chart>
              </div>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
    <vue-content-loading
      v-else
      :width="300"
      :height="150"
      primary="#bdc3c7"
      secondary="#95a5a6"
    >
      <svg:rect x="0" y="0" rx="3" ry="3" width="80" height="10" />
      <svg:rect x="180" y="0" rx="3" ry="3" width="55" height="10" />
      <svg:rect x="240" y="0" rx="3" ry="3" width="55" height="10" />

      <svg:rect x="0" y="20" rx="3" ry="3" width="180" height="10" />

      <svg:rect x="0" y="40" rx="3" ry="3" width="300" height="85" />
    </vue-content-loading>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as chartConfigs from "@/components/Charts/config";
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
import LineChart from "@/components/Charts/LineChart";
import LineLevelChart from "@/components/Charts/LineLevelChart";
import { VueContentLoading } from "vue-content-loading";
import BarChart from "@/components/Charts/BarChart";
import MetricInfoTooltip from "@/components/Levels/MetricInfoTooltip";
import formulaChangeHelpTextsMixin, { readStatisticsChangeDate } from "@/mixin/formulaChangeHelpTextsMixin";
import {
  INCIDENTS_HELP_TEXT,
  DEALER_WAIT_HELP_TEXT,
  RATINGS_HELP_TEXT
} from "@/utils/dailyMenuLevelHelpTexts";
import { getPeriodColor } from "@/utils/currentPeriodColors";

const MONTH_LABELS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default {
  mixins: [formulaChangeHelpTextsMixin(readStatisticsChangeDate)],
  components: {
    Tabs,
    TabPane,
    LineChart,
    LineLevelChart,
    BarChart,
    MetricInfoTooltip,
    VueContentLoading
  },
  data: () => ({
    INCIDENTS_HELP_TEXT,
    DEALER_WAIT_HELP_TEXT,
    RATINGS_HELP_TEXT,
    bigGeneralChart: {
      chartData: {
        labels: MONTH_LABELS,
        datasets: [
          {
            label: "General",
            data: []
          }
        ]
      },
      extraOptions: chartConfigs.blueChartOptions
    },
    bigClaimsRatioChart: {
      chartData: {
        labels: MONTH_LABELS,
        datasets: [
          {
            label: "Ratio de Incidencias",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      extraOptions: chartConfigs.barMetricChartOptions
    },
    bigRoutesChart: {
      chartData: {
        labels: MONTH_LABELS,
        datasets: [
          {
            label: "Exceso de espera (min)",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      extraOptions: chartConfigs.barMetricChartOptions
    },
    bigRatingsChart: {
      chartData: {
        labels: MONTH_LABELS,
        datasets: [
          {
            label: "Calificación de pedidos",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      extraOptions: chartConfigs.barMetricChartOptions
    },
    valPeriod: 0
  }),
  async mounted() {
    await this.GET_PROGRESS();
    await this.GET_PERIODS();
    this.initGeneral();
    this.initClaimsRatio();
    this.initRoutes();
    this.initRatings();
  },
  computed: {
    ...mapGetters("metrics", ["getProgress", "getMsgError", "getPeriods"])
  },
  methods: {
    ...mapActions("metrics", ["GET_PROGRESS", "GET_PERIODS"]),
    ...mapMutations("metrics", ["SET_MSG_ERROR"]),
    changePeriod(val) {
      this.valPeriod = val.target.value
      this.SET_MSG_ERROR(null);
      this.GET_PROGRESS({
        timeCutID: this.valPeriod
      }).then(() => {
        this.initGeneral();
        this.initClaimsRatio();
        this.initRoutes();
        this.initRatings();
      });
    },
    getPeriodColor(index) {
      return getPeriodColor(
        this.getProgress.days,
        this.getProgress.currentPeriodStartDate,
        index
      );
    },
    initGeneral: function(index) {
      this.bigGeneralChart.chartData = {
        datasets: [
          {
            label: "General",
            data: this.getProgress !== null ? this.getProgress.levels : [],
            borderColor: "#BABABA",
            borderWidth: 2,
            pointBorderColor: context => this.getPeriodColor(context.dataIndex),
            pointBackgroundColor: context => this.getPeriodColor(context.dataIndex)
          }
        ]
      };
      this.bigGeneralChart.chartData.labels =
        this.getProgress !== null ? this.getProgress.days : [];
    },
    initClaimsRatio: function(index) {
      this.bigClaimsRatioChart.chartData = {
        datasets: [
          {
            label: "Ratio de Incidencias",
            data:
              this.getProgress !== null ? this.getProgress.claimsRatios : [],
            backgroundColor: context => this.getPeriodColor(context.dataIndex)
          }
        ]
      };
      this.bigClaimsRatioChart.chartData.labels =
        this.getProgress !== null ? this.getProgress.days : [];
    },
    initRoutes: function(index) {
      this.bigRoutesChart.chartData = {
        datasets: [
          {
            label: "Exceso de espera (min)",
            data:
              this.getProgress !== null
                ? this.getProgress.averageWaitExcessMinutes
                : [],
            backgroundColor: context => this.getPeriodColor(context.dataIndex)
          }
        ]
      };
      this.bigRoutesChart.chartData.labels =
        this.getProgress !== null ? this.getProgress.days : [];
    },
    initRatings: function(index) {
      this.bigRatingsChart.chartData = {
        datasets: [
          {
            label: "Calificación de pedidos",
            data: this.getProgress !== null ? this.getProgress.ratings : [],
            backgroundColor: context => this.getPeriodColor(context.dataIndex)
          }
        ]
      };
      this.bigRatingsChart.chartData.labels =
        this.getProgress !== null ? this.getProgress.days : [];
    }
  },
  watch: {
  }
};
</script>
<style lang="scss" scoped>
.nav-link {
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: #2d2d2d !important;
  &.active {
  }
}
</style>
